/**
* @description: 抽奖记录
*/
<template>
    <div class="finance_box" ref="myElementRef">
        <div ref="searchBox">
            <hc-search :data="searchData" @serch="getSearch" />
        </div>
        <div class="table_box">
            <hc-table :loading="state.loading"
                :tableData="state.tableData"
                :column="state.tableHeader"
                :offsetHeight="state.offsetHeight"
                :maxPage="maxPage"
                @pageChange="pageChange"
                @limitChange="limitChange"
            >
                <template #is_redeemed="{ row }">
                    {{ row.is_redeemed == 1 || row.is_redeemed === true ? t('scoreLotteryRecord.redeemed') : t('scoreLotteryRecord.notRedeemed') }}
                </template>
            </hc-table>
        </div>
    </div>
</template>

<script setup>
import hcSearch from "@/components/hc-search/index.vue";
import hcTable from "@/components/hc-table/index.vue";
import { onMounted, reactive, ref, nextTick, onUnmounted, toRaw } from "vue";
import { adminRecordListApi } from "@/api/score/lottery.js";
import { listToMap } from "@/utils/utils";
import { usePageI18n } from "@/composables/usePageI18n.js";
import { applyScoreLotteryRecordLabels } from "@/utils/scoreListI18n.js";

const myElementRef = ref();
const searchBox = ref();

let page = ref(1);
let limit = ref(20);
let maxPage = ref(0);

const searchData = reactive([
    {
        label: "关键词",
        type: "input",
        value: "",
        field: "keywords",
        placeholder: "姓名/账号",
    },
]);

const state = reactive({
	loading: false,
    column: [
        { prop: "id", show: false, label: "ID" },
        { show: true, type: "index", label: "序号", width: 80 },
        { prop: "real_name", show: true, label: "用户姓名" },
        { prop: "username", show: true, label: "账号" },
        { prop: "level_name", show: true, label: "等级" },
        { prop: "prize_name", show: true, label: "奖品" },
        { prop: "points_tier", show: true, label: "积分档位", width: 100 },
        { prop: "is_redeemed", show: true, label: "兑换状态", width: 100 },
        { prop: "created_at", show: true, label: "抽奖时间", width: 180 },
    ],
    offsetHeight: 0,
    tableHeader: [],
    tableData: [],
});

const applyLabels = () => {
    applyScoreLotteryRecordLabels({ searchData, columns: state.column });
    tableHeaderFn();
};
const { t } = usePageI18n(applyLabels);

const offHeighths = () => {
    if (myElementRef.value) {
        state.offsetHeight =
            myElementRef.value?.offsetHeight - 90 - (searchBox.value?.offsetHeight || 0);
    }
};

const tableHeaderFn = () => {
    state.tableHeader = state.column.filter((v) => v.show);
};

const getSearch = (params = []) => {
    const form = listToMap(toRaw(params), { value: "value", key: "field" });
    state.loading = true
		adminRecordListApi(JSON.stringify({
        page: page.value,
        limit: limit.value,
        ...form,
    })).then((res) => {
        if (res.code === 200) {
            state.tableData = res.data || [];
            maxPage.value = res.maxPage ?? 0;
        } else {
            state.tableData = [];
            maxPage.value = 0;
        }
    }).finally(() => {
        state.loading = false;
    });
};

const pageChange = (currentPage) => {
    page.value = currentPage;
    getSearch(searchData);
};

const limitChange = (currentLimit) => {
    limit.value = currentLimit;
    page.value = 1;
    getSearch(searchData);
};

onMounted(() => {
    nextTick(() => offHeighths());
    window.onresize = () => nextTick(() => offHeighths());
    applyLabels();
    getSearch(searchData);
});

onUnmounted(() => {
    window.onresize = null;
});
</script>

<style lang="less" scoped>
.finance_box {
    flex: 1;
    overflow: auto;
    background-color: #fff;
    border-radius: 6px;
    padding: 10px;
    margin-right: 10px;
}

.table_box {
    width: 100%;
}
</style>
